import "servicestack/tags/pagination/tag-pagination.scss";
import "servicestack/tags/pagination/tag-pagination.client.scss";
import controller from "servicestack/tags/pagination/tag-pagination.controller";
import templateUrl from "servicestack/tags/pagination/tag-pagination.htm";

export default {
  bindings: {
    filter: "<",
    formatter: "<?",
    query: "<",
    layout: "@", //drawer, drawers, accordion, wrapped-accordion, none/transclude
    tagKind: "@",
    stateTo: "@",
    onSelected: "&"
  },
  controller,
  templateUrl
};
